<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-toolbar flat>
          <v-text-field v-model="userIdToMigrate" append-icon="mdi-rocket" label="User Id To Migrate" single-line
            hide-details>
          </v-text-field>
          <v-spacer></v-spacer>
          <v-btn @click="processMigration()" :loading="responseProcessing" color="primary" absolute right>Migrate
          </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-alert dismissible close-text="Close Alert" border="left" :type="responseStatus" v-if="responseStatus">
          {{ migrationResponseMessage }}
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import serverFunctions from "@/functions/serverFunctions";
import userFunctions from "@/functions/userFunctions";

export default {
  data: () => ({
    userIdToMigrate: null,
    responseStatus: null,
    migrationResponseMessage: null,
    responseProcessing: false
  }),
  computed: {
  },

  methods: {
    async processMigration() {

      if (!this.userIdToMigrate) {
        return;
      }

      this.responseProcessing = true;
      this.responseStatus = null;
      this.migrationResponseMessage = null;

      const userAvatarMigrationRequest = serverFunctions.getDataRequestObject(userFunctions.getLoggedInUser(), this.userIdToMigrate);
      let migrationResponse = await serverFunctions.getRawPostResponse("/migrateUserAvatar", userAvatarMigrationRequest);

      this.responseProcessing = false;

      if (migrationResponse) {
        this.responseStatus = "success";
        this.migrationResponseMessage = "Migration Successful";
      } else {
        this.responseStatus = "error";
        this.migrationResponseMessage = "Migration Failed";
      }

    },
    async processLinkRequest(linkItem, actionUrl) {
      this.editedItem.linkTypeId = this.listid;
      const deleteLinkRequest = serverFunctions.getLinkRequestObject(
        userFunctions.getLoggedInUser(),
        linkItem
      );
      await serverFunctions.getPostResponse(actionUrl, deleteLinkRequest);
      this.getLinkData();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      this.editedItem.linkTypeId = this.listid;
      if (this.editedIndex > -1) {
        await this.processLinkRequest(this.editedItem, this.LINK_URLS.UPDATE);
      } else {
        await this.processLinkRequest(this.editedItem, this.LINK_URLS.ADD);
      }
      this.close();
    },
  },
};
</script>

<style scoped>
</style>
